import React, {Component, useState} from 'react';
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import 'bootstrap/dist/css/bootstrap.min.css';

import {
    Accordion,
    AccordionItem,
    AccordionSkeleton, Button,
    ComboBox,
    Dropdown
} from "carbon-components-react";
import {Undo16} from "@carbon/icons-react";

import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

export default class extends Component {

    state = {
        isOppenedSubmit: false,
        skuisOpend: true,
        skuDetailsisOpenend: false,
        form: {
            period: "",
            cost_center: "",
        }
    };

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {

    }


    async handleChange(e) {
        //const name = event.target.name;
        //console.log(name);
        const {name, value} = e.target;
        this.setState(prevState => ({
            form: {
                ...prevState.form,
                [name]: value
            }
        }));
        //console.log(this.state);
    }

    handleSubmit = (e) => {
        window.location.href = '/ij/report_preview_edit_schneider/' + this.state.form.period + '/' + this.state.form.cost_center;
    }

    handleSetClear = (e) => {
        e.preventDefault();
        this.setState({
            form: {
                form: "",
                cost_center: "",
            }
        });

    }


    render() {
        let {data_cost_center, data_period, isLoading} = this.props;
        const {form, skuDetailsisOpenend} = this.state;


        let step2 = false;
        let buttonD = false;


        return (
            <div style={{minHeight: "80vh"}}>
                <form>
                    <div className="bx--row bx--fieldset">
                        <div className="bx--col-md-6 bx--col-lg-7 content-pt-1"><p>To generate a Review you need to
                            select Period and Filters options.</p></div>
                        <div className="bx--col-md-2 bx--col-lg-3 content-align-center">
                            <Button onClick={e => {
                                this.handleSubmit(e)
                            }} kind='primary'
                                    disabled={(this.state.form.period !== "" && this.state.form.cost_center !== "") ? false : true}>Generate
                                Review</Button>
                            <span className="content-ml-10">
                            <Button
                                hasIconOnly
                                renderIcon={Undo16}
                                tooltipAlignment="center"
                                tooltipPosition="bottom"
                                iconDescription="Reset"
                                kind='secondary'
                                onClick={e => {
                                    this.handleSetClear(e)
                                }}
                            />
                            </span>
                        </div>
                    </div>
                    {isLoading ? (
                        <AccordionSkeleton/>
                    ) : (
                        <Accordion className="bx--accordion-80">
                            <AccordionItem open="true" title="1. Period">
                                <div className={"clearfix"}>
                                    <div className="col-md-3 bx--col-padding bx--row-padding">
                                        <Dropdown
                                            disabled={skuDetailsisOpenend}
                                            useTitleInItem={false}
                                            id="period"
                                            name="Period"
                                            label="PERIOD"
                                            placeholder="PERIOD"
                                            invalid={false}
                                            invalidText="Invalid Selection"
                                            items={data_period}
                                            initialSelectedItems={[{id: form.period}]}
                                            itemToString={(item) => (item ? item.text : '')}
                                            onChange={(evt) => {
                                                this.setState(prevState => ({
                                                    form: {
                                                        ...prevState.form,
                                                        'period': evt.selectedItem.id
                                                    }
                                                }))
                                            }}
                                        />
                                    </div>
                                </div>
                            </AccordionItem>
                            <AccordionItem open={true} title="2. Filters">
                                <div className="clearfix">
                                    <div className="row bx--col-padding bx--row-padding" style={{paddingLeft: "20px"}}>
                                        <div className="col-md-6 bx--col-padding bx--row-padding">


                                            <Autocomplete
                                                id="combo-box-demo"
                                                options={data_cost_center}
                                                getOptionLabel={(option) => option.label}
                                                style={{width: "100%"}}
                                                renderInput={(params) => <TextField {...params} label="COST CENTER"
                                                                                    variant="standard"/>}

                                                autoHighlight
                                                disableClearable
                                                onChange={(event, newValue) => {
                                                    this.setState(prevState => ({
                                                        form: {
                                                            ...prevState.form,
                                                            'cost_center': newValue.id
                                                        }
                                                    }))
                                                }}


                                            />


                                        </div>
                                    </div>
                                </div>
                            </AccordionItem>
                        </Accordion>
                    )}
                </form>
            </div>
        );
    }
}
